<div class="navbar bg-[#293f54] text-primary-content shadow px-4">
  <div class="flex-1 gap-3">
    <button class="btn btn-ghost btn-sm btn-circle" (click)="toggleSnav()">
      <span class="material-icons-outlined">menu</span>
    </button>
    <span class="font-semibold text-lg">
      @if (nomeAzienda) {
        {{ nomeAzienda }} - {{ 'ASSET_INVENTORY' | translate }}
      } @else {
        {{ 'ASSET_INVENTORY' | translate }}
      }
    </span>
  </div>
  <div class="flex-none gap-2">

    <!-- Language picker -->
    <div class="dropdown dropdown-end">
      <button tabindex="0" class="btn btn-ghost btn-sm gap-2">
        <span class="fi fi-{{ currentFlag() }}"></span>
        <span class="hidden sm:inline text-sm">{{ getLanguageTranslationKey() | translate }}</span>
        <span class="material-icons-outlined text-base leading-none">expand_more</span>
      </button>
      <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-50 w-44 p-2 shadow text-base-content">
        @for (lang of languages; track lang.code) {
          <li>
            <button class="flex items-center gap-2" (click)="changeLang(lang.code)">
              <span class="fi fi-{{ lang.flag }}"></span>
              <span>{{ lang.key | translate }}</span>
            </button>
          </li>
        }
      </ul>
    </div>

    <app-account-data></app-account-data>
  </div>
</div>
